// * React components
import React, { Suspense, lazy } from 'react';
// * Third party components
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { TermsOfUse } from './Components/V2/SitePolicy/TermsOfUse';
import { PrivatePolicy } from './Components/V2/SitePolicy/PrivatePolicy';
import CookieModal from './Components/Cookies/CookieModal';
import MarketingLayout from './Components/SEO/MarketingLayout';
import MainSection from './Components/V3/F&Q/MainSection';
import { BookDemoProvider } from './Utils/ContextHelper/BookDemoContext';

// import Contactus from './Components/V1/InnerPages/ContactUs/Contactus';
// import SimsolaLoader from './Components/V1/Loader/SimsolaLoader';

// * Pages;

// const MainPage = lazy(() => import('./Components/V1/InnerPages/ContactUs/Contactus'));
const ResultPage = lazy(() => import('./Components/V2/InnerPages/Result/Result'));
const Resources = lazy(() => import('./Components/V2/InnerPages/Resources/Resources'));
const GuideTemplates = lazy(() => import('./Components/V2/InnerPages/Resources/GuideTemplates'));
const Blog = lazy(() => import('./Components/V2/InnerPages/Resources/Blog'));
const AboutUs = lazy(() => import('./Components/V2/InnerPages/AboutUs/AboutUs'));
const MainPage = lazy(() => import('./Components/V3/Landing/MainPage'));
const VisionPage = lazy(() => import('./Components/V2/Vision/Vision'));
const ContactUsPage = lazy(() => import('./Components/V2/InnerPages/ContactUs/ContactUs'));
const ProductPage = lazy(() => import('./Components/V2//Product/Product'));
const DemoPage = lazy(() => import('./Components/V2/BookADemo/BookDemo'));
const ResourceDownloadPage = lazy(() => import('./Components/V2/ResourceDownload/ResourceDownloadPage'));
const Simsola6D = lazy(() => import('./Components/V2/InnerPages/Simsola6D/Simsola6D'));
const AssessmentService = lazy(() => import('./Components/V2/InnerPages/AssessmentService/AssessmentService'));
const AssessmentServiceCandidates = lazy(() => import('./Components/V2/InnerPages/AssessmentServiceCandidates/AssessmentServiceCandidates'));
const Login = lazy(() => import('./Components/V2/admin/login/login'));
const Dashboard = lazy(() => import('./Components/V2/admin/dashboard'));
const ManagedUsers = lazy(() => import('./Components/V2/admin/managed-users'));
const Blogs = lazy(() => import('./Components/V2/admin/blogs'));
const WorkShops = lazy(() => import('./Components/V2/admin/Workshop'));
const WorkShop = lazy(() => import('./Components/V2/InnerPages/Resources/Workshop/Workshop'));
const GuideTemplate = lazy(() => import('./Components/V2/admin/Guide & Template'));
const Event = lazy(() => import('./Components/V2/admin/Event'));
const DemoRequests = lazy(() => import('./Components/V2/admin/demo-requests'));
const SingleEvent = lazy(() => import('./Components/V2/InnerPages/Resources//Event/SingleEvent'));
const TrustCenter = lazy(() => import('./Components/V2/TrustCenter/TrustCenter'));
const NewsAward = lazy(() => import('./Components/V2/Award/NewsAward'));
const GuideTemplateDetail = lazy(() => import('./Components/V2/InnerPages/Resources/GuideTemplateDetail'));
export const AppRoutes = () => {
	return (
		<>
			<BrowserRouter>
				<Suspense fallback={<div>Loading...</div>}>
					<CookieModal />
					<BookDemoProvider>
					<Routes>
						<Route element={<MarketingLayout />}>
							<Route path="/" element={<MainPage />} />
							<Route path="/about-us" element={<AboutUs />} />
							<Route path="/results" element={<ResultPage />} />
							<Route path="/resources" element={<Resources />} />
							<Route path="/resources/:slug" element={<GuideTemplates />} />
							<Route path="/resources/blog/:slug" element={<Blog />} />
							<Route path="/resources/workshop/:slug" element={<WorkShop />} />
							<Route path="/resources/event&webinar/:slug" element={<SingleEvent />} />
							<Route path="/resources/guide-template/:id" element={<GuideTemplateDetail />} />
							<Route path="/news/tmn-choice-awards-2026" element={<NewsAward />} />
							<Route path="/vision" element={<VisionPage />} />
							<Route path="/contact-us" element={<ContactUsPage />} />
							<Route path="/product" element={<ProductPage />} />
							<Route path="/product/6d-assessment" element={<Simsola6D />} />
							<Route path="/assessment-service" element={<AssessmentService />} />
							<Route path="/assessment-service/candidates" element={<AssessmentServiceCandidates />} />
							<Route path="/book-a-demo" element={<DemoPage />} />
							<Route path="/resource-download" element={<ResourceDownloadPage />} />
							<Route path="/terms-of-use" element={<TermsOfUse />} />
							<Route path="/privacy-policy" element={<PrivatePolicy />} />
							<Route path="/trust-center" element={<TrustCenter />} />
							<Route path="/frequently-asked-questions" element={<MainSection />} />
						</Route>
						<Route path="/administration-access" element={<Login />} />
						<Route path="/administration-access/dashboard" element={<Dashboard />} />
						<Route path="/administration-access/managed-users" element={<ManagedUsers />} />
						<Route path="/administration-access/blogs" element={<Blogs />} />
						<Route path="/administration-access/workshop" element={<WorkShops />} />
						<Route path="/administration-access/guide&template" element={<GuideTemplate />} />
						<Route path="/administration-access/event" element={<Event />} />
				<Route path="/administration-access/demo-requests" element={<DemoRequests />} />
					</Routes>
					</BookDemoProvider>
				</Suspense>
			</BrowserRouter>
		</>
	);
};
